import axios from 'axios';
import { WeatherPreferences, WeatherApiResponse, StationDetails } from '../types/weather';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://weather-backend-879484113802.us-central1.run.app/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // 30 seconds for BigQuery queries
});

// Request interceptor for debugging
api.interceptors.request.use((config) => {
  console.log('API Request:', config.method?.toUpperCase(), config.url, config.data);
  return config;
});

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    
    if (error.response?.status === 400) {
      throw new Error(error.response.data.error || 'Invalid request parameters');
    }
    
    if (error.response?.status === 500) {
      throw new Error('Server error occurred. Please try again later.');
    }
    
    if (error.code === 'ECONNABORTED') {
      throw new Error('Request timed out. BigQuery may be processing a large dataset.');
    }
    
    throw new Error(error.response?.data?.message || 'Network error occurred');
  }
);

export const weatherApi = {
  // Expose the axios instance for content service
  api,

  async findMatches(preferences: WeatherPreferences): Promise<WeatherApiResponse> {
    const response = await api.post<WeatherApiResponse>('/weather/find-match', preferences);
    return response.data;
  },

  async getStationDetails(stationId: string): Promise<StationDetails> {
    const response = await api.get<{ success: boolean; data: StationDetails }>(`/weather/station/${stationId}`);
    return response.data.data;
  },

  async healthCheck(): Promise<{ status: string; timestamp: string }> {
    const response = await api.get<{ status: string; timestamp: string }>('/health');
    return response.data;
  }
};
